export enum Salutation {
    None = 0,
    Frau = 1,
    Herr = 2
}



// WEBPACK FOOTER //
// ./src/app/enums/salutation.enum.ts